// extracted by mini-css-extract-plugin
export default {"slider_container":"collective_slider_container__B9xXC"};